export enum NoticeDisplaySeverity {
  OPEN = 'Open',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
}

export enum NoticeSourceType {
  FORCE_MAJEURE = 'FORCE_MAJEURE',
  PLANNED_SERVICE_OUTAGE = 'PLANNED_SERVICE_OUTAGE',
  MAINTENANCE = 'MAINTENANCE',
  CAPACITY_CONSTRAINT = 'CAPACITY_CONSTRAINT',
  OPERATIONAL_ALERT = 'OPERATIONAL_ALERT',
  PIPELINE_CONDITIONS = 'PIPELINE_CONDITIONS',
  OPERATIONAL_FLOW_ORDER = 'OPERATIONAL_FLOW_ORDER',
  OVER_UNDER_PERFORMANCE = 'OVER_UNDER_PERFORMANCE',
  OTHER = 'OTHER',
  MAINTENANCE_SCHEDULE = 'MAINTENANCE_SCHEDULE',
  CONSTRAINED_AREAS = 'CONSTRAINED_AREAS',
}

/*
export interface NoticeRecordSibling {
  record_id: number | null;
  identifier: string | null;
  date_range: string | null;
  direction: string | null;
}
*/

export type NoticeRecord = {
  id: number;
  notice_file_path: string;
  created_at: string;
  updated_at: string;
  notice_id: number;
  prior_notice_id: number | null;
  start_gas_date: string;
  end_gas_date: string;
  effective_datetime: string | null;
  nomination_cycle: string;
  nomination_cycle_rank: number;
  raw_flow_direction: string;
  additional_information: string | null;
  identifier: string;
  identifier_type: string;
  priority: string;
  priority_type: string;
  capacity: number | null;
  capacity_units: string | null;
  capacity_type: string | null;
  percentage: number | null;
  percentage_type: string | null;
  reason: string;
  full_text: string;
  metadata: string; // serialized JSON string
  group_type: string | null;
  group_id: number | null;
  tsp: number;
  tsp_name: string;
  flow_direction: string | null;
  nodes: number[] | null;
  points: number[] | null;
  max_record_id: number | null;
  extracted_notice: number;
  notice_component: number;
  source_type: NoticeSourceType;
  capacity_component_id?: number;
  capacity_component_name?: string;
  display_values: {
    text: string;
    severity: NoticeDisplaySeverity;
    effect_text: string | null;
    date_range: string | null;
    direction: string | null;
  };
  display_daterange: string;
  display_details: {
    text: string;
    severity: NoticeDisplaySeverity;
    date_range: string | null;
    effect_text: string | null;
    subject: string | null;
    posted: string | null;
    notice_type: string | null;
    parse_state: string | null;
    direction: string | null;
    prior_record_id: number | null;
    supersede_record_id: number | null;
    // siblings: NoticeRecordSibling[];
  };
  has_capacity_component: boolean;
  has_point: boolean;
  has_node: boolean;
  resolved_supersede_notice_id: number | null;
  resolved_prior_notice_id: number | null;
};

export type NoticeRecordListItem = Pick<
  NoticeRecord,
  | 'id'
  | 'notice_id'
  | 'identifier'
  | 'notice_component'
  | 'reason'
  | 'start_gas_date'
  | 'end_gas_date'
  | 'nomination_cycle'
  | 'tsp'
  | 'tsp_name'
  | 'points'
  | 'notice_file_path'
  | 'source_type'
  | 'capacity_component_id'
  | 'capacity_component_name'
  | 'display_values'
  | 'display_daterange'
  | 'has_capacity_component'
  | 'has_point'
  | 'has_node'
  | 'effective_datetime'
  | 'percentage'
  | 'priority'
  | 'capacity'
  | 'capacity_units'
  | 'identifier_type'
>;

export type MaintenanceNoticeRecord = Pick<
  NoticeRecord,
  | 'id'
  | 'notice_id'
  | 'identifier'
  | 'notice_component'
  | 'reason'
  | 'start_gas_date'
  | 'end_gas_date'
  | 'tsp'
  | 'tsp_name'
  | 'points'
  | 'notice_file_path'
  | 'source_type'
  | 'capacity_component_id'
  | 'capacity_component_name'
  | 'display_values'
  | 'display_daterange'
  | 'has_capacity_component'
  | 'has_point'
  | 'has_node'
>;
